import { jsx, jsxs } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { Avatar, Radio, Space } from "antd";
import { useTranslation } from "@inscore/shared";
import { getTabLabel } from "./tabComponentsService";
import TabsScrollWrapper from "./../tabsScrollWrapper/TabsScrollWrapper.js";
const TabsTabItems = ({
  activeTabData,
  tabItemId,
  setTabsActiveTabId,
  radioStyleType = "default"
}) => {
  const tabsTabItems = useMemo(
    () => {
      var _a;
      return (_a = activeTabData == null ? void 0 : activeTabData.metadata.items) != null ? _a : [];
    },
    [activeTabData == null ? void 0 : activeTabData.metadata.items]
  );
  const { t } = useTranslation();
  const handleTabsActiveTabChange = (e) => setTabsActiveTabId(e.target.value);
  return tabsTabItems.length > 1 ? /* @__PURE__ */ jsx(TabsScrollWrapper, { activeTabData, children: /* @__PURE__ */ jsx(
    Radio.Group,
    {
      buttonStyle: "solid",
      value: tabItemId,
      onChange: handleTabsActiveTabChange,
      className: radioStyleType === "secondary" ? "radio-group-secondary" : "radio-group-default",
      children: tabsTabItems.map((item) => /* @__PURE__ */ jsx(Radio.Button, { value: item.id, children: /* @__PURE__ */ jsxs(Space, { size: 12, children: [
        item.iconUrl && /* @__PURE__ */ jsx(Avatar, { size: "small", src: item.iconUrl }),
        getTabLabel(item.name) === "All" ? t("all") : item.name
      ] }) }, item.id))
    }
  ) }) : null;
};
var stdin_default = memo(TabsTabItems);
export {
  stdin_default as default
};
